import React, { useEffect, useState } from "react";

import { confirmSignUp } from "aws-amplify/auth";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

import { Button, Icon, Notification, Text, Title } from "@ui/elements";
import { Stack } from "@ui/layout";

import i18n from "../../services/translation/i18n";

let didInitiateVerification = false;

export const VerifyAccount = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const { t } = useTranslation();

  const verifyAccount = async () => {
    setLoading(true);

    try {
      await confirmSignUp({
        confirmationCode: token as string,
        username: email as string,
        options: {
          clientMetadata: {
            locale: i18n.language,
            partnerId: process.env.REACT_APP_PARTNER_ID!,
          },
        },
      });
    } catch (error) {
      setLoading(false);

      if (error instanceof Error) {
        return setError(error.message);
      }

      setError(String(error));
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!didInitiateVerification) {
      didInitiateVerification = true;
      verifyAccount();
    }
  }, []);

  if (loading) {
    return <Text>{t("messages.verifying-account")}</Text>;
  }

  const errorMessage =
    error && error !== "User cannot be confirmed. Current status is CONFIRMED"
      ? t(error)
      : "";

  return (
    <Stack direction="column">
      {!errorMessage && (
        <>
          <Stack align="center" gap="xxs">
            <Icon
              className="has-text-success"
              icon="CheckCircle"
              size="medium"
            />
            <Title size={5}>{t("messages.account-verified")}</Title>
          </Stack>
          <Text>{t("messages.account-verified-info")}</Text>
        </>
      )}
      {errorMessage && (
        <Notification color="danger">{errorMessage}</Notification>
      )}
      <Link to="/login">
        <Button color="primary" isFullwidth>
          {t("labels.login")}
        </Button>
      </Link>
    </Stack>
  );
};
